import { AppBar, Box, Button, CardContent, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, FormLabel, InputLabel, List, ListItem, ListItemIcon, ListItemText, Modal, Radio, RadioGroup, Switch, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, colors } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import api from '../../../services/api';
import { AFORMA_PDV_SISARE_MULTI, AGENERO_SERVICO_AEREO, AGENERO_SERVICO_CRUZEIRO, AGENERO_SERVICO_HOSPEDAGEM, AGENERO_SERVICO_LOCADORAVEICULOS, AGENERO_SERVICO_OPCIONAL, AGENERO_SERVICO_OUTROS, AGENERO_SERVICO_OUTROSVIAGENS, AGENERO_SERVICO_PACOTEVIAGENS, AGENERO_SERVICO_SEGUROVIAGEM, AGENERO_SERVICO_SERVICOVIAGENS, AGENERO_SERVICO_TRANSPORTE, ANAO, ASIM, ATIPO_SERVICOAPOIO_IDA, ATIPO_SERVICOAPOIO_RETORNO, ATIPOFORNEC_GUIA, ATIPOFORNEC_MOTORISTA, ATIPOFORNEC_OUTROS, ATIPOFORNEC_TRANSPORTE, ATIPOSERVICO_REGULAR, tDialeto, tPais } from 'consts';
import PropTypes from 'prop-types';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import ComboSetor from 'views/Components/ComboSetor';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import moment from 'moment';
import FormHelperText from '@material-ui/core/FormHelperText';
import ComboPadrao from 'views/Components/ComboPadrao';
import ComboTipoServico from 'views/Components/ComboTipoServico';
import SearchCidade from 'views/Components/SearchCidade';
import { getConfigField, loadCompany } from 'lib/configUtils';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';
import HorarioPadraoServico from './HorarioPadraoServico';
import FornecedorServicoForm from './FornecedorServicoForm';
import GrupoServicoForm from './GrupoServicoForm';

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

// Definição dos estilos
const styles = theme => ({
    textField: {
        marginTop: theme.spacing(0), // Margem superior
        marginBottom: "0.5rem", // Margem inferior
        marginRight: "0.5rem", // Margem direita
    },
    addButton: {
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        float: 'right', // alinhamento a direita
    },
    textarea: {
        width: '100%',
        height: '100px',
        padding: theme.spacing(1),
        boxSizing: 'border-box',
    },
    dialogContent: {
        padding: theme.spacing(2),
    },

});

class ServicoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            servico: {},
            categoriasservico: [],
            centrosreceita: [],
            setoresreceita: [],
            centrosdespesa: [],
            setoresdespesa: [],
            servicosvinctransp: [],
            afinidadesservico: [],
            locais: [],
            empresa: {},
            selectedCity: null,
            activetab: 0,
            activeTabDescritivo: 0,
            isUpdatingAfinidade: false,
            pdvsservico: [],
            isUpdatingPDV: false,
            horariosservico: [],
            fornecedoresservico: [],
            isLoadingFornecedor: true,
            isFornecedorDeleteModalOpen: false,
            selectedIdFornecedor: 0,
            selectedNomeFornecedor: '',
            openFornecedorServicoForm: false,
            selectedFornecedor: {},
            selectedIndexFornecedor: -1,
            servicosgrupo: [],
            isLoadingServGrupo: true,
            selectedIdServicoGrupo: 0,
            selectedIndexServicoGrupo: -1,
            selectedNomeServicoGrupo: '',
            isServicoGrupoDeleteModalOpen: false,
            openServicoGrupoForm: false,
            selectedServicoGrupo: {},
            isNewRecord: false,
            isView: false,
            schema: {
                usuario: {
                    presence: { allowEmpty: false, message: 'é obrigatório' },
                    length: {
                        maximum: 64
                    }
                },
            },

            useStyles: makeStyles(theme => ({
                root: {
                    backgroundColor: theme.palette.background.default,
                    height: '100%'
                },
                grid: {
                    height: '100%'
                },
                quoteContainer: {
                    [theme.breakpoints.down('md')]: {
                        display: 'none'
                    }
                },
                quote: {
                    backgroundColor: theme.palette.neutral,
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundImage: 'url(/images/auth.jpg)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                },
                quoteInner: {
                    textAlign: 'center',
                    flexBasis: '600px'
                },
                quoteText: {
                    color: theme.palette.white,
                    fontWeight: 300
                },
                name: {
                    marginTop: theme.spacing(3),
                    color: theme.palette.white
                },
                bio: {
                    color: theme.palette.white
                },
                contentContainer: {},
                content: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                },
                contentHeader: {
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: theme.spacing(5),
                    paddingBototm: theme.spacing(2),
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2)
                },
                logoImage: {
                    marginLeft: theme.spacing(4)
                },
                contentBody: {
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    [theme.breakpoints.down('md')]: {
                        justifyContent: 'center'
                    }
                },
                form: {
                    paddingLeft: 100,
                    paddingRight: 100,
                    paddingBottom: 125,
                    flexBasis: 700,
                    [theme.breakpoints.down('sm')]: {
                        paddingLeft: theme.spacing(2),
                        paddingRight: theme.spacing(2)
                    }
                },
                title: {
                    marginTop: theme.spacing(3)
                },
                socialButtons: {
                    marginTop: theme.spacing(3)
                },
                socialIcon: {
                    marginRight: theme.spacing(1)
                },
                sugestion: {
                    marginTop: theme.spacing(2)
                },
                textField: {
                    marginTop: theme.spacing(2)
                },
                signInButton: {
                    margin: theme.spacing(2, 0)
                },
                alert: {
                    color: '#FF0000',
                }
            })),
        };
    }

    loadLookup = async (resource, id, query = '') => {
        const numericId = Number(id);
        const path = Number.isSafeInteger(numericId) && numericId > 0
            ? `/${resource}/listforchange/${numericId}`
            : `/${resource}/active/true`;
        const response = await api.get(path + query);
        return { data: Array.isArray(response.data) ? response.data : (response.data.data || []) };
    };

    async componentDidMount() {
        try {
            await this.loadServico();
        } catch (error) {
            const data = error.response && error.response.data;
            this.setState({ loadFailed: true, isView: true });
            this.handleOpenAlert('Não foi possível carregar os dados do serviço. ' +
                ((data && (data.error || data.message || data.mensagem)) || error.message));
        }
    }

    async loadServico() {
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;

        const vincservaservtransp = (getConfigField('vincservaservtransp') == ASIM);
        const trabmaisumaafinidadeservico = (getConfigField('trabmaisumaafinidadeservico') == ASIM);
        const multipdv = (getConfigField('formapdv') == AFORMA_PDV_SISARE_MULTI);

        if (id >= 0) {
            const response = await api.get(`/servico/${id}`);

            if (!response.data.data || !response.data.data[0]) {
                throw new Error('Serviço não encontrado.');
            }
            this.setState({
                servico: response.data.data[0],
                activeTab: '1',
                activeTabDescritivo: '1',
                isNewRecord: false,
                SelectedCategoriaServico: response.data.data[0].codcategoriaservico,
                isView: (currentPath.includes('/view'))
            });

            const { servico } = this.state;
            servico.hspadraoservico = moment(servico.hspadraoservico).format("HH:mm");
            servico.horaordappcli = moment(servico.horaordappcli).format("HH:mm");
            servico.hsunicapresopcguia = moment(servico.hsunicapresopcguia).format("HH:mm");
            this.setState({ servico: servico });

            const categoriasservico = await this.loadLookup('categoriaservico', response.data.data[0].codcategoriaservico, '');
            this.setState({ categoriasservico: categoriasservico.data });

            const centrosreceita = await this.loadLookup('financas/centroreceitadespesa', response.data.data[0].codcreditodebito, '?tipoconta=A&tipolancamento=C');
            this.setState({ centrosreceita: centrosreceita.data });

            const setoresreceita = await this.loadLookup('setor', response.data.data[0].codsetor, '');
            this.setState({ setoresreceita: setoresreceita.data });

            const centrosdespesa = await this.loadLookup('financas/centroreceitadespesa', response.data.data[0].codcreditodebitodespesa, '?tipoconta=A&tipolancamento=D');
            this.setState({ centrosdespesa: centrosdespesa.data });

            const setoresdespesa = await this.loadLookup('setor', response.data.data[0].codsetordespesa, '');
            this.setState({ setoresdespesa: setoresdespesa.data });

            if (vincservaservtransp) {
                const servicosvinctransp = await this.loadLookup('servico', response.data.data[0].codservtransp, '');
                this.setState({ servicosvinctransp: servicosvinctransp.data });
            }

            // Busca as cidades
            const cidades = Number(response.data.data[0].codcidadeservico) > 0
                ? await this.loadLookup('cidade', response.data.data[0].codcidadeservico) : { data: [] };
            // Encontre a cidade correspondente ao codcidade
            let cidadeSelecionada = cidades.data.find(cidade => Number(cidade.codcidade) === Number(response.data.data[0].codcidadeservico));

            if (cidadeSelecionada == undefined) {
                cidadeSelecionada = {};
            }
            this.setState({ selectedCity: cidadeSelecionada });

            if (trabmaisumaafinidadeservico) {
                const afinidadesservico = await api.get(`/servico/afinidade/${id}`);
                this.setState({ afinidadesservico: afinidadesservico.data });
            } else {
                const afinidadesservico = await this.loadLookup('afinidadeservico', response.data.data[0].idafinidade, '');
                this.setState({ afinidadesservico: afinidadesservico.data });
            }

            const locais = await this.loadLookup('local', response.data.data[0].codlocal, '');
            this.setState({ locais: locais.data });

            if (multipdv) {
                const pdvsservico = await api.get(`/servico/pdv/${id}`);
                this.setState({ pdvsservico: pdvsservico.data });
            }

            const fornecedoresservico = await api.get(`/fornecedorservico/servico/${id}`);
            this.setState({ fornecedoresservico: fornecedoresservico.data });

            const servicosgrupo = await api.get(`/servico/grupo/${id}`);
            this.setState({ servicosgrupo: servicosgrupo.data });

            this.loadFornecServ();
            this.loadServGrupo();
        }
        else if (id === 'novo') {
            this.setState({
                activeTab: '1',
                activeTabDescritivo: '1',
                isNewRecord: true
            });
            this.state.isNewRecord = true;
            const { servico } = this.state;
            servico.figuranoticketreceptivo = ASIM;
            servico.servicopordiaria = ANAO;
            servico.escalavel = ASIM;
            servico.codcidadeservico = getConfigField('codcidade', 'empresa');
            servico.categoriasservico = -1;
            servico.centrosreceita = -1;
            servico.setoresreceita = -1;
            servico.centrosdespesa = -1;
            servico.setoresdespesa = -1;
            servico.servicosvinctransp = -1;
            // servico.cidades = -1;
            servico.afinidadesservico = -1;
            servico.locais = -1;
            servico.tiposervpadrao = ATIPOSERVICO_REGULAR;
            this.setState({ servico: servico });
            const categoriasservico = await this.loadLookup('categoriaservico', null, '');
            this.setState({ categoriasservico: categoriasservico.data });
            const centrosreceita = await this.loadLookup('financas/centroreceitadespesa', null, '?tipoconta=A&tipolancamento=C');
            this.setState({ centrosreceita: centrosreceita.data });
            const setoresreceita = await this.loadLookup('setor', null, '');
            this.setState({ setoresreceita: setoresreceita.data });
            const centrosdespesa = await this.loadLookup('financas/centroreceitadespesa', null, '?tipoconta=A&tipolancamento=D');
            this.setState({ centrosdespesa: centrosdespesa.data });
            const setoresdespesa = await this.loadLookup('setor', null, '');
            this.setState({ setoresdespesa: setoresdespesa.data });

            if (vincservaservtransp) {
                const servicosvinctransp = await this.loadLookup('servico', null, '');
                this.setState({ servicosvinctransp: servicosvinctransp.data });
            }

            // Busca as cidades
            const cidades = Number(servico.codcidadeservico) > 0
                ? await this.loadLookup('cidade', servico.codcidadeservico) : { data: [] };
            // Encontre a cidade correspondente ao codcidade
            let cidadeSelecionada = cidades.data.find(cidade => Number(cidade.codcidade) === Number(servico.codcidadeservico));

            if (cidadeSelecionada == undefined) {
                cidadeSelecionada = {};
            }
            this.setState({ selectedCity: cidadeSelecionada });

            if (trabmaisumaafinidadeservico) {
                const afinidadesservico = await api.get(`/servico/afinidade/0`);
                this.setState({ afinidadesservico: afinidadesservico.data });
            } else {
                const afinidadesservico = await this.loadLookup('afinidadeservico', null, '');
                this.setState({ afinidadesservico: afinidadesservico.data });
            }

            const locais = await this.loadLookup('local', null, '');
            this.setState({ locais: locais.data });

            if (multipdv) {
                const pdvsservico = await api.get(`/servico/pdv/0`);
                this.setState({ pdvsservico: pdvsservico.data });
            }
        }
    }

    /* evento on change componentes */
    OnChange = (event) => {
        const { servico } = this.state;
        const { name, type, value, checked } = event.target;
        let adjustedValue = value; // Valor ajustado com base no tipo do input

        // Decide o tratamento com base no tipo do input ou nome
        switch (type) {
            case 'checkbox':
                // Usa o valor checked para campos do tipo checkbox
                // Tratamentos adicionais específicos para campos
                if (name === 'inativo') {
                    if (checked === false) {
                        adjustedValue = ASIM;
                    }
                    else {
                        adjustedValue = ANAO;
                    }
                }
                else {
                    if (checked === false) {
                        adjustedValue = ANAO;
                    } else {
                        adjustedValue = ASIM;
                    }
                }

                if (name === 'escalavel') {
                    if (checked === true) {
                        if ((servico.servicoaereo === ASIM) || (servico.servicohospedagem === ASIM)) {
                            adjustedValue = ANAO;
                            this.handleOpenAlert('Não é possível marcar como escalável este gênero de serviço!');
                        }
                    } else {
                        if (servico.servicotransporte === ASIM) {
                            adjustedValue = ASIM;
                            this.handleOpenConfirmation('Serviço de transporte é recomendável que seja ' +
                                'marcado como escalável para serviços executados ' +
                                'pela empresa. Continuar sem marcar como escalável?')
                        }

                        servico.escalaautomatica = ANAO;
                    }
                } else if (name === 'servicopasseio') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_OPCIONAL;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicohospedagem = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicoservicoviagens = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicooutrosviagens = ANAO;
                    }
                } else if (name === 'servicooutros') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_OUTROS;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicoservicoviagens = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicooutrosviagens = ANAO;
                    }
                } else if (name === 'servicotransporte') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_TRANSPORTE;

                        servico.servicooutros = ANAO;
                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicoseguroviagem = ANAO;
                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicoservicoviagens = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicooutrosviagens = ANAO;
                    } else {
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;
                    }
                } else if (name === 'transferin') {
                    if (checked === true) {
                        servico.transferout = ANAO;
                    }
                } else if (name === 'transferout') {
                    if (checked === true) {
                        servico.transferin = ANAO;
                    }
                } else if (name === 'servicoaereo') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_AEREO;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicoservicoviagens = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicooutrosviagens = ANAO;

                        servico.escalavel = ANAO;
                    }
                } else if (name === 'servicohospedagem') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_HOSPEDAGEM;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicoservicoviagens = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicooutrosviagens = ANAO;

                        servico.escalavel = ANAO;
                    }
                } else if (name === 'servicoseguroviagem') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_SEGUROVIAGEM;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoaereo = ANAO;

                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicoservicoviagens = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicooutrosviagens = ANAO;
                    }
                } else if (name === 'servicolocadoraveiculos') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_LOCADORAVEICULOS;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicoservicoviagens = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicooutrosviagens = ANAO;
                    }
                } else if (name === 'servicoservicoviagens') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_SERVICOVIAGENS;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicooutrosviagens = ANAO;
                    }
                } else if (name === 'servicocruzeiro') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_CRUZEIRO;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicoservicoviagens = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicooutrosviagens = ANAO;
                    }
                } else if (name === 'servicopacoteviagens') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_PACOTEVIAGENS;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicoservicoviagens = ANAO;
                        servico.servicocruzeiro = ANAO;
                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicooutrosviagens = ANAO;
                    }
                } else if (name === 'servicooutrosviagens') {
                    if (checked === true) {
                        servico.codigogenero = AGENERO_SERVICO_OUTROSVIAGENS;

                        servico.servicotransporte = ANAO;
                        servico.transferin = ANAO;
                        servico.transferout = ANAO;
                        servico.servtranspvintarifcidade = ANAO;

                        servico.servicopasseio = ANAO;
                        servico.servicohospedagem = ANAO;
                        servico.servicooutros = ANAO;
                        servico.servicoaereo = ANAO;
                        servico.servicoseguroviagem = ANAO;

                        servico.servicoservicoviagens = ANAO;
                        servico.servicopacoteviagens = ANAO;
                        servico.servicolocadoraveiculos = ANAO;
                        servico.servicocruzeiro = ANAO;
                    }
                } else if (name === 'controlapontuacao') {
                    if (checked === false) {
                        servico.pontos = 0;
                        servico.essencialparapontuacao = ANAO;
                    }
                } else if (name === 'servicopordiaria') {
                    if (checked === true) {
                        servico.consideraadt = ANAO;
                        servico.considerachd = ANAO;
                        servico.considerainf = ANAO;
                        servico.considerasen = ANAO;
                    }
                } else if (name === 'controladisponibilidade') {
                    if (checked === false) {
                        servico.contrrigdisponib = ANAO;

                        servico.consideraadt = ANAO;
                        servico.considerachd = ANAO;
                        servico.considerainf = ANAO;
                        servico.considerasen = ANAO;

                        servico.controleunicosaldo = ANAO;
                    }
                } else if (name === 'contrrigdisponib') {
                    if (checked === false) {
                        servico.consideraadt = ANAO;
                        servico.considerachd = ANAO;
                        servico.considerainf = ANAO;
                        servico.considerasen = ANAO;
                    }
                } else if (name === 'permitemeiaentrada') {
                    if (checked === false) {
                        servico.percdescmeiaentrada = 0;
                    }
                } else if (name === 'servicoapoio') {
                    if (checked === false) {
                        servico.tiposervicoapoio = 0;
                    }
                }
                break;
            case 'select-one':
                adjustedValue = Number(value);
                break;
            case 'radio':
                adjustedValue = Number(value);
                break;
            case 'textarea':
                break;
            default:
                if ((name == 'perccomissvendedor') || (name === 'perciss') || (name === 'custounitadt') ||
                    (name === 'custounitchd') || (name === 'custounitinf') || (name === 'custounit') ||
                    (name === 'precofixoreaispdvmovel') || (name === 'precofixoreaischdpdvmovel') ||
                    (name === 'precofixodolarpdvmovel') || (name === 'precofixodolarchdpdvmovel') ||
                    (name === 'custounitsen') || (name === 'pontos') || (name === 'percdescmeiaentrada') ||
                    (name === 'codservsnowadt') || (name === 'codservsnowchd') || (name === 'codservsnowsen') ||
                    (name === 'codservsnowinf') || (name === 'sortorder') || (name === 'perciva') ||
                    (name === 'percivaisento')) {
                    adjustedValue = Number(value.replace(/\./g, '').replace(',', '.'));
                } else if (!((name == 'referenciacodbarrapulseira') || (name == 'duracao') ||
                    (name == 'descservicoappcli'))) {
                    adjustedValue = value.toUpperCase();
                }
                break;
        }

        // Atualiza o estado com o valor ajustado
        servico[name] = adjustedValue;
        this.setState({ servico: servico });
    };

    /* evento on change lista de afinidades */
    OnChangeAfinidade = (event) => {
        const { afinidadesservico } = this.state;
        const { checked, id } = event.target;
        const { isUpdatingAfinidade } = this.state;

        if (checked === false) {
            afinidadesservico[id].marcado = ANAO;
        } else {
            afinidadesservico[id].marcado = ASIM;
        }

        this.setState({
            afinidadesservico: afinidadesservico,
            isUpdatingAfinidade: true
        });
    };

    /* evento on change lista de pdvs */
    OnChangePDV = (event) => {
        const { pdvsservico } = this.state;
        const { checked, id } = event.target;
        const { isUpdatingPDV } = this.state;

        if (checked === false) {
            pdvsservico[id].marcado = ANAO;
        } else {
            pdvsservico[id].marcado = ASIM;
        }

        this.setState({
            pdvsservico: pdvsservico,
            isUpdatingPDV: true
        });
    };

    /* atualiza dados de serviço existente - post */
    atualizaServico = async () => {
        const { servico } = this.state;
        servico.codusuarioalterou = parseInt(sessionStorage.getItem('codUser'));

        /* monta lista de afinidades */
        const { isUpdatingAfinidade } = this.state;
        if (isUpdatingAfinidade === true) {
            const { afinidadesservico } = this.state;

            let afinidades = [];
            for (let i = 0; i <= afinidadesservico.length - 1; i++) {
                if (afinidadesservico[i].marcado === ASIM) {
                    afinidades.push({ idafinidade: afinidadesservico[i].id });
                }
            }

            servico['afinidades'] = afinidades;
        }

        /* monta lista de pdvs */
        const { isUpdatingPDV } = this.state;
        if (isUpdatingPDV === true) {
            const { pdvsservico } = this.state;

            let pdvs = [];
            for (let i = 0; i <= pdvsservico.length - 1; i++) {
                if (pdvsservico[i].marcado === ASIM) {
                    pdvs.push({ codpdv: pdvsservico[i].codpdvconfig });
                }
            }

            servico['pdvs'] = pdvs;
        }
        /* */

        try {
            const response = await api.put(`/servico/${servico.codservico}`, servico);
            if (response.status === 200) {
                this.props.history.push('/front/servicos');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* abre janela de confirmação com mensagem */
    handleOpenConfirmation = (message) => {
        this.setState({ openConfirmation: true });
        this.setState({ messageConfirmation: message });
    };

    /* fecha janela de confirmação */
    handleCloseConfirmation = () => {
        this.setState({ openConfirmation: false });
    }

    /* confirmação */
    handleConfirmation = async (message) => {
        const { servico } = this.state;

        /* verifica motivo da confirmação */
        if (message === 'Serviço de transporte é recomendável que seja ' +
            'marcado como escalável para serviços executados ' +
            'pela empresa. Continuar sem marcar como escalável?') {
            servico.escalavel = ANAO;
        }

        this.setState({ servico: servico });
        this.setState({ openConfirmation: false });
    };

    /* Click salvar */
    onClickSave = () => {
        if (this.state.loadFailed) return;
        if (this.validationRequiredFields()) {
            if (this.state.isNewRecord) {
                this.insereServico()
            }
            else {
                this.atualizaServico();
            }
        }
    }

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/front/servicos');
    }

    /* valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { servico } = this.state;
        let retorno = true;

        if ((String(servico.descservico).trim() === '') || (servico.descservico === undefined)) {
            servico.descservico = '';
            this.setState({ servico: servico });
            retorno = false;
        }

        if ((String(servico.abreviatura).trim() === '') || (servico.abreviatura === undefined)) {
            servico.abreviatura = '';
            this.setState({ servico: servico });
            retorno = false;
        }

        return retorno;
    }

    /* insere novo serviço */
    insereServico = async () => {
        const { servico } = this.state;
        servico.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));

        /* monta lista de afinidades */
        const { isUpdatingAfinidade } = this.state;
        if (isUpdatingAfinidade === true) {
            const { afinidadesservico } = this.state;

            let afinidades = [];
            for (let i = 0; i <= afinidadesservico.length - 1; i++) {
                if (afinidadesservico[i].marcado === ASIM) {
                    afinidades.push({ idafinidade: afinidadesservico[i].id });
                }
            }

            servico['afinidades'] = afinidades;
        }

        /* monta lista de pdvs */
        const { isUpdatingPDV } = this.state;
        if (isUpdatingPDV === true) {
            const { pdvsservico } = this.state;

            let pdvs = [];
            for (let i = 0; i <= pdvsservico.length - 1; i++) {
                if (pdvsservico[i].marcado === ASIM) {
                    pdvs.push({ codpdv: pdvsservico[i].codpdvconfig });
                }
            }

            servico['pdvs'] = pdvs;
        }

        /* monta lista de horários */
        const { horariosservico } = this.state;
        if (horariosservico) {
            servico['horariospadroes'] = horariosservico;
        }

        /* monta lista de fornecedores */
        const { fornecedoresservico } = this.state;
        if (fornecedoresservico.length > 0) {
            let fornecedores = [];
            for (let i = 0; i <= fornecedoresservico.length - 1; i++) {
                fornecedores.push({
                    codfornecedor: fornecedoresservico[i].codfornecedor,
                    tipofornec: fornecedoresservico[i].tipofornec,
                    centrocustooutrofornec: fornecedoresservico[i].centrocustooutrofornec
                });
            }

            servico['fornecedores'] = fornecedores;
        }

        /* monta lista de serviços grupo */
        const { servicosgrupo } = this.state;
        if (servicosgrupo.length > 0) {
            let servgrupo = [];
            for (let i = 0; i <= servicosgrupo.length - 1; i++) {
                servgrupo.push({
                    codservicogrupo: servicosgrupo[i].codservicogrupo
                });
            }

            servico['servicosgrupo'] = servgrupo;
        }

        /* */

        try {
            const response = await api.post(`/servico`, servico);
            if (response.status === 200) {
                this.props.history.push('/front/servicos');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({ activetab: value });
        this.setState({ activetabdescritivo: 0 });
    };

    handleChangeTabDescritivo = (event, value) => {
        this.setState({ activetabdescritivo: value });
    };


    /* verifica se tem erro campos atendimento */
    hasErrorField = (field, value) => {

    }

    // Função que será passada como prop para o CitySearch
    handleCitySelection = (city) => {
        let { servico } = this.state;
        servico.codcidadeservico = city.codcidade;
        this.setState({ selectedCity: city, servico: servico });
    };

    /* abre janela de horários padrões */
    handleOpenHorariosPadroes = () => {
        this.setState({ openHorariosPadroes: true });
    };

    /* fecha janela de horários padrões */
    handleCloseHorariosPadroes = () => {
        this.setState({ openHorariosPadroes: false });
    }

    getTipoFornec(id) {
        switch (id) {
            case ATIPOFORNEC_GUIA:
                return 'Guia';
                break;
            case ATIPOFORNEC_TRANSPORTE:
                return 'Transporte';
                break;
            case ATIPOFORNEC_MOTORISTA:
                return 'Motorista';
                break;
            case ATIPOFORNEC_OUTROS:
                return 'Outros';
                break;
        }
    }

    loadFornecServ = async () => {
        const { fornecedoresservico } = this.state;
        const fornecList = fornecedoresservico;

        const fornecCodes = [...new Set(fornecList.map(fornecedor => fornecedor.codfornecedor))];
        try {
            const servFornec = await this.fetchFornec(fornecCodes);
            this.setState({ servFornec: servFornec, isLoadingFornecedor: false });
        } catch (error) {
            console.error("Erro ao buscar fornecedores:", error);
            this.setState({ isLoadingFornecedor: false });
        }
    };

    fetchFornec = async (fornecCodes) => {
        try {
            const response = await api.post('/fornecedor/findlist', {
                listid: fornecCodes
            });

            const servFornec = response.data.reduce((acc, fornecedor) => {
                acc[fornecedor.codfornecedor] = fornecedor.fantasia;
                return acc;
            }, {});
            return servFornec;
        } catch (error) {
            console.error('Erro ao buscar fornecedores:', error);
        }
    };

    /* evento on change lista de fornecedores */
    OnChangeFornecedor = (event) => {
        const { servico } = this.state;
        const { checked, id } = event.target;

        if (checked === false) {
            servico.codfornecprincipal = Number(0);
        } else {
            servico.codfornecprincipal = Number(id);
        }

        this.setState({ servico: servico });
    };

    /* abre janela de confirmação exclusão de fornecedor */
    openFornecedorDeleteModal = (idfornecedor, index, nomefornecedor) => {
        this.setState({
            selectedIdFornecedor: idfornecedor,
            selectedIndexFornecedor: index
        });
        this.setState({ selectedNomeFornecedor: nomefornecedor });
        this.setState({ isFornecedorDeleteModalOpen: true });
    };

    /* fecha janela de confirmação exclusão de fornecedor */
    closeFornecedorDeleteModal = () => {
        this.setState({ isFornecedorDeleteModalOpen: false });
    };

    /* remover fornecedor da lista off e atualizar na sequencia */
    removeFornecedorEReorganizarSequencia(index) {
        const { fornecedoresservico } = this.state;

        fornecedoresservico.splice(index, 1);

        fornecedoresservico.map((fornecedor, idx) => (
            fornecedoresservico[idx].chave = idx + 1
        ));

        this.setState({ fornecedoresservico: fornecedoresservico });
    }

    /* deleta fornecedor */
    handleDeleteFornecedor = async (id, index) => {
        const { isNewRecord } = this.state;
        try {
            if (!(isNewRecord)) {
                const response = await api.delete(`/fornecedorservico/${id}`);
                // Verifica se a exclusão foi bem-sucedida
                if (response.status === 200) {
                    try {
                        this.closeFornecedorDeleteModal();
                        this.updateFornecedorList();
                    } catch (error) {
                        console.error('Erro ao fechar o modal:', error);
                    }
                }
            }
            else {
                this.removeFornecedorEReorganizarSequencia(index);
                this.closeFornecedorDeleteModal();
            }

        } catch (error) {
            this.closeFornecedorDeleteModal();
            this.handleOpenAlert(error.response.data.error);
            console.log(error);
            console.log(error.message);
        }
    };

    // Método para atualizar a lista de fornecedores
    updateFornecedorList = async (fornecedor) => {
        const fornecedoroff = fornecedor;
        try {
            if (!(this.state.isNewRecord)) {
                const fornecedoresservico = await api.get(`/fornecedorservico/servico/${this.state.servico.codservico}`);
                if (fornecedoresservico.status === 200) {
                    this.setState({ fornecedoresservico: fornecedoresservico.data });
                }
            }
            else {
                const { fornecedoresservico } = this.state;
                const index = fornecedoresservico.findIndex(fornecedor => fornecedor.chave === fornecedoroff.chave);

                if (index !== -1) {
                    fornecedoresservico[index] = fornecedoroff;
                    this.setState({ fornecedoresservico: fornecedoresservico });
                } else {
                    const novoFornecedor = fornecedoroff;
                    novoFornecedor.chave = (this.state.fornecedoresservico.length + 1);

                    fornecedoresservico.push(novoFornecedor);

                    // Atualiza o estado com a nova lista de fornecedores
                    this.setState({ fornecedoresservico: fornecedoresservico });
                }
            }

            this.loadFornecServ();
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* open form fornecedor modal */
    openFornecedorModal = (id = 'novo') => {
        let fornecedorEncontrado = {};

        if (this.state.isNewRecord) {
            if (!(id === 'novo')) {
                const idfornecedorProcurado = parseInt(id, 10);
                fornecedorEncontrado = this.state.fornecedoresservico.find(fornecedor => fornecedor.chave === idfornecedorProcurado);
            }
        }

        this.setState({
            openFornecedorServicoForm: true,
            selectedIdFornecedor: id,
            selectedFornecedor: fornecedorEncontrado
        });
    };

    handleFornecedorServicoFormClose = () => {
        this.setState({ openFornecedorServicoForm: false });
    };

    loadServGrupo = async () => {
        const { servicosgrupo } = this.state;
        const servgrupoList = servicosgrupo;

        const servgrupoCodes = [...new Set(servgrupoList.map(servicogrupo => servicogrupo.codservicogrupo))];
        try {
            const servGrupo = await this.fetchServGrupo(servgrupoCodes);
            this.setState({ servGrupo: servGrupo, isLoadingServGrupo: false });
        } catch (error) {
            console.error("Erro ao buscar serviços grupo:", error);
            this.setState({ isLoadingServGrupo: false });
        }
    };

    fetchServGrupo = async (servgrupoCodes) => {
        try {
            const response = await api.post('/servico/findlist', {
                listid: servgrupoCodes
            });

            const servGrupo = response.data.data.reduce((acc, servico) => {
                acc[servico.codservico] = servico.descservico;
                return acc;
            }, {});
            return servGrupo;
        } catch (error) {
            console.error('Erro ao buscar serviços do grupo:', error);
        }
    };

    /* abre janela de confirmação exclusão de serviço grupo */
    openServicoGrupoDeleteModal = (idservicogrupo, index, nomeservico) => {
        this.setState({
            selectedIdServicoGrupo: idservicogrupo,
            selectedIndexServicoGrupo: index
        });
        this.setState({ selectedNomeServicoGrupo: nomeservico });
        this.setState({ isServicoGrupoDeleteModalOpen: true });
    };

    /* fecha janela de confirmação exclusão de serviço grupo */
    closeServicoGrupoDeleteModal = () => {
        this.setState({ isServicoGrupoDeleteModalOpen: false });
    };

    /* deleta serviço grupo */
    handleDeleteServicoGrupo = async (id, index) => {
        const { isNewRecord } = this.state;
        try {
            if (!(isNewRecord)) {
                const response = await api.delete(`/servico/grupo/${id}`);
                // Verifica se a exclusão foi bem-sucedida
                if (response.status === 200) {
                    try {
                        this.closeServicoGrupoDeleteModal();
                        this.updateServicoGrupoList();
                    } catch (error) {
                        console.error('Erro ao fechar o modal:', error);
                    }
                }
            }
            else {
                this.removeServicoGrupoEReorganizarSequencia(index);
                this.closeServicoGrupoDeleteModal();
            }
        } catch (error) {
            this.closeServicoGrupoDeleteModal();
            this.handleOpenAlert(error.response.data.error);
            console.log(error);
            console.log(error.message);
        }
    };

    // Método para atualizar a lista de serviços grupo
    updateServicoGrupoList = async (servicogrupo) => {
        const servicogrupooff = servicogrupo;
        try {
            if (!(this.state.isNewRecord)) {
                const servicosgrupo = await api.get(`/servico/grupo/${this.state.servico.codservico}`);
                if (servicosgrupo.status === 200) {
                    this.setState({ servicosgrupo: servicosgrupo.data });
                }
            }
            else {
                const { servicosgrupo } = this.state;
                const index = servicosgrupo.findIndex(servicogrupo => servicogrupo.id === servicogrupooff.id);

                if (index !== -1) {
                    servicosgrupo[index] = servicogrupooff;
                    this.setState({ servicosgrupo: servicosgrupo });
                } else {
                    const novoServicoGrupo = servicogrupooff;
                    novoServicoGrupo.id = (this.state.servicosgrupo.length + 1);

                    servicosgrupo.push(novoServicoGrupo);

                    // Atualiza o estado com a nova lista de serviços grupo
                    this.setState({ servicosgrupo: servicosgrupo });
                }
            }

            this.loadServGrupo();
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* remover serviço grupo da lista off e atualizar na sequencia */
    removeServicoGrupoEReorganizarSequencia(index) {
        const { servicosgrupo } = this.state;

        servicosgrupo.splice(index, 1);

        servicosgrupo.map((servicogrupo, idx) => (
            servicosgrupo[idx].chave = idx + 1
        ));

        this.setState({ servicosgrupo: servicosgrupo });
    }

    /* open form serviço grupo modal */
    openServicoGrupoModal = (id = 'novo') => {
        let servicogrupoEncontrado = {};

        this.setState({
            openServicoGrupoForm: true,
            selectedIdServicoGrupo: id,
            selectedServicoGrupo: servicogrupoEncontrado
        });
    };

    handleServicoGrupoFormClose = () => {
        this.setState({ openServicoGrupoForm: false });
    };

    render() {
        const { classes } = this.props;

        const { activetab } = this.state;
        const { activetabdescritivo } = this.state;
        const { servico } = this.state;
        const { categoriasservico } = this.state;
        const { centrosreceita } = this.state;
        const { setoresreceita } = this.state;
        const { centrosdespesa } = this.state;
        const { setoresdespesa } = this.state;
        const { servicosvinctransp } = this.state;
        const { afinidadesservico } = this.state;
        const { locais } = this.state;
        const { selectedCity } = this.state;
        const { pdvsservico } = this.state;
        const { fornecedoresservico } = this.state;
        const { servFornec, isLoadingFornecedor } = this.state;
        const { servicosgrupo } = this.state;
        const { servGrupo, isLoadingServGrupo } = this.state;

        // dados empresa
        const empresa = loadCompany();

        // campos configurações
        const vendehospedagem = (getConfigField('vendehospedagem') == ASIM);
        const vendetransporte = (getConfigField('vendetransporte') == ASIM);
        const vendeaereo = (getConfigField('vendeaereo') == ASIM);
        const vendeopcionais = (getConfigField('vendeopcionais') == ASIM);
        const controlaservicoscompulseira = (getConfigField('controlaservicoscompulseira') == ASIM);
        const coddialeto = getConfigField('coddialeto');
        const codpais = getConfigField('codpais');
        const controladisponibservico = (getConfigField('controladisponibservico') == ASIM);
        const exibecustopadraocadservico = (getConfigField('exibecustopadraocadservico') == ASIM);
        const vincservaservtransp = (getConfigField('vincservaservtransp') == ASIM);
        const controlapontosservico = (getConfigField('controlapontosservico') == ASIM);
        const exibenomeservnoforneccadserv = (getConfigField('exibenomeservnoforneccadserv') == ASIM);
        const vendeseguroviagem = (getConfigField('vendeseguroviagem') == ASIM);
        const recebdiretofornec = (getConfigField('recebdiretofornec') == ASIM);
        const detalhaformapgtofornec = (getConfigField('detalhaformapgtofornec') == ASIM);
        const contrservrecebfornec = (getConfigField('contrservrecebfornec') == ASIM);
        const exportsnowland = (getConfigField('exportsnowland') == ASIM);
        const carrodeapoio = (getConfigField('carrodeapoio') == ASIM);
        const vendelocadoraveiculos = (getConfigField('vendelocadoraveiculos') == ASIM);
        const vendeservicosviagens = (getConfigField('vendeservicosviagens') == ASIM);
        const vendecruzeiros = (getConfigField('vendecruzeiros') == ASIM);
        const vendepacotesviagens = (getConfigField('vendepacotesviagens') == ASIM);
        const vendeoutrosviagens = (getConfigField('vendeoutrosviagens') == ASIM);
        const trabprogramacaosugestivo = (getConfigField('trabprogramacaosugestivo') == ASIM);
        const trabhsservdiaespec = (getConfigField('trabhsservdiaespec') == ASIM);
        const hsunicapresopcguia = (getConfigField('hsunicapresopcguia') == ASIM);
        const trabtipopadraoservico = (getConfigField('trabtipopadraoservico') == ASIM);
        const trabmaisumaafinidadeservico = (getConfigField('trabmaisumaafinidadeservico') == ASIM);
        const multipdv = (getConfigField('formapdv') == AFORMA_PDV_SISARE_MULTI);
        const trabgruposervico = (getConfigField('trabgruposervico') == ASIM);

        return (
            <div>
                <AppBar
                    color="default"
                    position="static"
                >
                    <Tabs
                        indicatorColor="primary"
                        onChange={this.handleChangeTab}
                        scrollButtons="auto"
                        scrollable
                        variant="scrollable"
                        textColor="primary"
                        value={activetab}
                    >
                        <Tab
                            // icon={<AssignmentIcon />}
                            label="Dados"
                        />

                        <Tab
                            label="Descritivo"
                        />

                        <Tab
                            style={{ display: ((!(empresa && empresa.modulopdvmovel && empresa.modulovendatablet === ANAO)) ? '' : 'none') }}
                            label="PDV Móvel"
                        />

                        <Tab
                            label="Fornecedores"
                        />

                        <Tab
                            style={{ display: ((!(empresa && empresa.moduloadmappcli === ANAO)) ? '' : 'none') }}
                            label="App Cliente"
                        />

                        <Tab
                            style={{ display: ((exportsnowland) ? '' : 'none') }}
                            label="Snowland"
                        />

                        <Tab
                            style={{ display: ((carrodeapoio) ? '' : 'none') }}
                            label={((servico.servicoapoio == ASIM) ? "Configurar serviço de apoio" : "Serviços de Apoio")}
                        />

                        <Tab
                            style={{ display: ((codpais == tPais['APAISCHILE']) ? '' : 'none') }}
                            label="Impostos"
                        />

                        <Tab
                            style={{ display: ((trabgruposervico) ? '' : 'none') }}
                            label="Grupo"
                        />
                    </Tabs>
                </AppBar>
                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Serviço {servico.codservico} - {servico.descservico}
                    </Typography>

                    <br />
                    <br />

                    {/* Aba Dados */}
                    {activetab === 0 &&
                        <TabContainer>
                            <FormGroup row={true}>
                                <TextField
                                    className={this.state.useStyles.textField}
                                    label="Nome do serviço"
                                    style={{ width: '84.5%', marginTop: '10px', marginRight: '1%' }}
                                    name="descservico"
                                    value={servico.descservico || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    helperText={servico.descservico === '' ? 'Nome do serviço obrigatório' : ' '}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 100 }}
                                />

                                <TextField
                                    className={this.state.useStyles.textField}
                                    label="Abreviatura"
                                    style={{ width: '14.5%', marginTop: '10px' }}
                                    name="abreviatura"
                                    value={servico.abreviatura || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    helperText={servico.abreviatura === '' ? 'Abreviatura obrigatória' : ' '}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 10 }}
                                />
                            </FormGroup>

                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={!(servico.inativo === ASIM)}
                                        name="inativo"
                                        onChange={this.OnChange}
                                        color="primary"
                                        disabled={this.state.isView}
                                    />
                                }
                                label={(servico.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                            />

                            <br />
                            <br />

                            <FormControl
                                fullWidth
                                variant="outlined"
                                disabled={this.state.isView}
                            >
                                <ComboPadrao
                                    name={'codcategoriaservico'}
                                    label={'Categoria Serviço'}
                                    value={servico.codcategoriaservico}
                                    onChange={this.OnChange}
                                    fieldId={'codcategoriaservico'}
                                    listItems={categoriasservico}
                                    fieldDescription={'desccategoriaservico'}
                                />
                                <FormHelperText>{servico.codcategoriaservico === '0' ? 'Categoria obrigatório' : ' '}</FormHelperText>
                            </FormControl>


                            <br />
                            <br />

                            <Divider style={{ backgroundColor: colors.grey[400] }} />

                            <Typography style={{ marginTop: '5px', color: colors.grey[600] }}>
                                Gênero
                            </Typography>

                            <Typography style={{ marginTop: '5px', marginLeft: '10px', color: colors.grey[600] }}>
                                Receptivo
                            </Typography>

                            <FormGroup row={true}>

                                <FormGroup row={true} style={{ marginLeft: '30px' }}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.servicopasseio === ASIM)}
                                                    name="servicopasseio"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView || (!(vendeopcionais))}
                                                />}
                                            label={'Opcionais'}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.servicooutros === ASIM)}
                                                    name="servicooutros"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView}
                                                />}
                                            label={'Outros'}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.servicotransporte === ASIM)}
                                                    name="servicotransporte"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView || (!(vendetransporte))}
                                                />}
                                            label={'Transporte'}
                                        />
                                    </FormGroup>
                                </FormGroup>

                                <FormGroup row={true} style={{ marginLeft: '20px' }}>
                                    <Divider
                                        orientation="vertical"
                                        style={{
                                            backgroundColor: colors.grey[400],
                                            display: ((servico.servicotransporte == ASIM) ? '' : 'none')
                                        }}
                                        flexItem
                                    />

                                    <FormGroup
                                        style={{
                                            marginLeft: '10px',
                                            display: ((servico.servicotransporte == ASIM) ? '' : 'none')
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.transferin === ASIM)}
                                                    name="transferin"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView}
                                                />}
                                            label={'Transfer IN'}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.transferout === ASIM)}
                                                    name="transferout"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView}
                                                />}
                                            label={'Transfer OUT'}
                                        />
                                    </FormGroup>

                                    <FormGroup
                                        style={{
                                            display: ((servico.servicotransporte == ASIM) ? '' : 'none')
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.servtranspvintarifcidade === ASIM)}
                                                    name="servtranspvintarifcidade"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView}
                                                />}
                                            label={'Vínculo tarifário de cidade'}
                                        />
                                    </FormGroup>

                                    <Divider
                                        orientation="vertical"
                                        style={{
                                            backgroundColor: colors.grey[400],
                                            display: ((servico.servicotransporte == ASIM) ? '' : 'none')
                                        }}
                                        flexItem
                                    />
                                </FormGroup>
                            </FormGroup>

                            <Typography style={{ marginTop: '5px', marginLeft: '10px', color: colors.grey[600] }}>
                                Viagens
                            </Typography>

                            <FormGroup row={true} style={{ marginLeft: '30px' }} >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicoaereo === ASIM)}
                                            name="servicoaereo"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (!(vendeaereo))}
                                        />}
                                    label={'Aéreo'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicohospedagem === ASIM)}
                                            name="servicohospedagem"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (!(vendehospedagem))}
                                        />}
                                    label={'Hospedagem'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicoseguroviagem === ASIM)}
                                            name="servicoseguroviagem"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (!(vendeseguroviagem))}
                                        />}
                                    label={'Seguro Viagem'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicoservicoviagens === ASIM)}
                                            name="servicoservicoviagens"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (!(vendeservicosviagens))}
                                        />}
                                    label={'Serviço'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicolocadoraveiculos === ASIM)}
                                            name="servicolocadoraveiculos"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (!(vendelocadoraveiculos))}
                                        />}
                                    label={'Locação de Veículos'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicopacoteviagens === ASIM)}
                                            name="servicopacoteviagens"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (!(vendepacotesviagens))}
                                        />}
                                    label={'Pacotes'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicocruzeiro === ASIM)}
                                            name="servicocruzeiro"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (!(vendecruzeiros))}
                                        />}
                                    label={'Cruzeiro'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicooutrosviagens === ASIM)}
                                            name="servicooutrosviagens"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (!(vendeoutrosviagens))}
                                        />}
                                    label={'Outros'}
                                />
                            </FormGroup>

                            <Divider style={{ backgroundColor: colors.grey[400], marginTop: '10px' }} />

                            <br />

                            <Divider style={{ backgroundColor: colors.grey[400] }} />

                            <Typography style={{ marginTop: '5px', color: colors.grey[600] }}>
                                Opções
                            </Typography>

                            <FormGroup row={true}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.naofiguraroomlist === ASIM)}
                                            name="naofiguraroomlist"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Não figura no room list'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.figuranoticketreceptivo === ASIM)}
                                            name="figuranoticketreceptivo"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Figura no ticket receptivo'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.ignoracontrolerigidotarifa === ASIM)}
                                            name="ignoracontrolerigidotarifa"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Ignora controle rígido de tarifa'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicopordiaria === ASIM)}
                                            name="servicopordiaria"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Serviço por quantidade'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.escalavel === ASIM)}
                                            name="escalavel"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Escalável'}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.escalaautomatica === ASIM)}
                                            name="escalaautomatica"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView || (servico.escalavel === ANAO)}
                                        />}
                                    label={'Escala automática do serviço'}
                                />

                                {controladisponibservico && (<FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.controladisponibilidade === ASIM)}
                                            name="controladisponibilidade"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Controla disponibilidade de opcionais'}
                                />)}

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.obrigavalorservico === ASIM)}
                                            name="obrigavalorservico"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Obriga informar valor no lançamento'}
                                />

                                <FormGroup row={true}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(servico.permitemeiaentrada === ASIM)}
                                                name="permitemeiaentrada"
                                                onChange={this.OnChange}
                                                color="primary"
                                                disabled={this.state.isView}
                                            />}
                                        label={'Permite meia-entrada'}
                                    />

                                    <CurrencyTextField
                                        className={this.state.useStyles.textField}
                                        label=""
                                        style={{
                                            width: '100px', marginRight: '10px',
                                            display: ((servico.permitemeiaentrada == ASIM) ? '' : 'none')
                                        }}
                                        name="percdescmeiaentrada"
                                        id="percdescmeiaentrada"
                                        value={servico.percdescmeiaentrada || ''}
                                        variant="outlined"
                                        size="small"
                                        currencySymbol="%"
                                        outputFormat="number"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        onChange={this.OnChange}
                                        disabled={this.state.isView}
                                        minimumValue="0"
                                    />
                                </FormGroup>

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.bloqueiaservico === ASIM)}
                                            name="bloqueiaservico"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Serviço bloqueável'}
                                />

                                {carrodeapoio && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(servico.servicoapoio === ASIM)}
                                                name="servicoapoio"
                                                onChange={this.OnChange}
                                                color="primary"
                                                disabled={this.state.isView}
                                            />}
                                        label={'Serviço de apoio'}
                                    />)
                                }

                                {trabprogramacaosugestivo && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(servico.exibeprogrsugest === ASIM)}
                                                name="exibeprogrsugest"
                                                onChange={this.OnChange}
                                                color="primary"
                                                disabled={this.state.isView}
                                            />}
                                        label={'Exibe programação sugestiva'}
                                    />)
                                }

                                {trabhsservdiaespec && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(servico.definehsdiaespecif === ASIM)}
                                                name="definehsdiaespecif"
                                                onChange={this.OnChange}
                                                color="primary"
                                                disabled={this.state.isView}
                                            />}
                                        label={'Define horário serviço por dia específico'}
                                    />)
                                }

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.servicoterceirizado === ASIM)}
                                            name="servicoterceirizado"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Serviço terceirizado'}
                                />
                            </FormGroup>

                            <Divider style={{ backgroundColor: colors.grey[400], marginTop: '10px' }} />

                            <Button
                                color="primary"
                                style={{
                                    backgroundColor: colors.grey[300],
                                    color: 'black',
                                    marginTop: '10px'
                                }}
                                // className={classes.addButton}
                                variant="contained"
                                onClick={this.handleOpenHorariosPadroes}
                                disabled={this.state.isView}
                            >
                                Horários padrões
                            </Button>

                            <Divider style={{ backgroundColor: colors.grey[400], marginTop: '10px' }} />

                            <FormGroup
                                style={{
                                    display: ((servico.controladisponibilidade == ASIM) ? '' : 'none')
                                }}
                            >
                                <FormGroup row={true}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(servico.contrrigdisponib === ASIM)}
                                                name="contrrigdisponib"
                                                onChange={this.OnChange}
                                                color="primary"
                                                disabled={this.state.isView}
                                            />}
                                        label={'Controle rígido de disponibilidade para venda'}
                                    />

                                    <FormGroup
                                        row={true}
                                        style={{
                                            display: (((servico.contrrigdisponib == ASIM) && ((servico.servicopordiaria == ANAO))) ? '' : 'none')
                                        }}
                                    >
                                        <Divider
                                            orientation="vertical"
                                            style={{
                                                backgroundColor: colors.grey[400],
                                                marginTop: '5px', marginBottom: '5px'
                                            }}
                                            flexItem
                                        />

                                        <Typography style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                            marginRight: '10px',
                                            color: colors.grey[700]
                                        }}>
                                            Considerar na soma
                                        </Typography>

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.consideraadt === ASIM)}
                                                    name="consideraadt"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView}
                                                />}
                                            label={'ADT'}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.considerachd === ASIM)}
                                                    name="considerachd"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView}
                                                />}
                                            label={'CHD'}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.considerainf === ASIM)}
                                                    name="considerainf"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView}
                                                />}
                                            label={'INF'}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={(servico.considerasen === ASIM)}
                                                    name="considerasen"
                                                    onChange={this.OnChange}
                                                    color="primary"
                                                    disabled={this.state.isView}
                                                />}
                                            label={'SEN'}
                                        />

                                        <Divider
                                            orientation="vertical"
                                            style={{
                                                backgroundColor: colors.grey[400],
                                                marginTop: '5px', marginBottom: '5px'
                                            }}
                                            flexItem
                                        />

                                    </FormGroup>
                                </FormGroup>

                                {multipdv && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(servico.controleunicosaldo === ASIM)}
                                                name="controleunicosaldo"
                                                onChange={this.OnChange}
                                                color="primary"
                                                disabled={this.state.isView}
                                            />}
                                        label={'Estoque único'}
                                    />)
                                }

                            </FormGroup>

                            <Divider style={{
                                backgroundColor: colors.grey[400],
                                display: ((servico.controladisponibilidade == ASIM) ? '' : 'none')
                            }} />

                            <FormGroup row={true}>
                                <FormControl
                                    fullWidth
                                    style={{
                                        marginTop: '1rem',
                                        width: '49.5%',
                                        marginRight: '1%'
                                    }}
                                    variant="outlined"
                                    disabled={this.state.isView}
                                >
                                    <InputLabel htmlFor="outlined-age-native-simple">Centro de Receita</InputLabel>

                                    <ComboPadrao
                                        name={'codcreditodebito'}
                                        label={'Centro de Receita'}
                                        value={servico.codcreditodebito}
                                        onChange={this.OnChange}
                                        fieldId={'codcreditodebito'}
                                        listItems={centrosreceita}
                                        fieldDescription={'desccreditodebito'}
                                    />

                                </FormControl>

                                <FormControl
                                    fullWidth
                                    style={{
                                        marginTop: '1rem',
                                        width: '49.5%'
                                    }}
                                    variant="outlined"
                                    disabled={this.state.isView}
                                >
                                    <InputLabel htmlFor="outlined-age-native-simple">Setor da Receita</InputLabel>

                                    <ComboSetor
                                        name={'codsetor'}
                                        label={'Setor da Receita'}
                                        value={servico.codsetor}
                                        onChange={this.OnChange}
                                        fieldId={'codsetor'}
                                        listItems={setoresreceita}
                                        fieldDescription={'descsetor'}
                                    />

                                </FormControl>
                            </FormGroup>

                            <FormGroup row={true}>
                                <FormControl
                                    fullWidth
                                    style={{
                                        marginTop: '1rem',
                                        width: '49.5%',
                                        marginRight: '1%'
                                    }}
                                    variant="outlined"
                                    disabled={this.state.isView}
                                >
                                    <InputLabel htmlFor="outlined-age-native-simple">Centro de Despesa</InputLabel>

                                    <ComboPadrao
                                        name={'codcreditodebitodespesa'}
                                        label={'Centro de Despesa'}
                                        value={servico.codcreditodebitodespesa}
                                        onChange={this.OnChange}
                                        fieldId={'codcreditodebito'}
                                        listItems={centrosdespesa}
                                        fieldDescription={'desccreditodebito'}
                                    />
                                </FormControl>

                                <FormControl
                                    fullWidth
                                    style={{
                                        marginTop: '1rem',
                                        width: '49.5%'
                                    }}
                                    variant="outlined"
                                    disabled={this.state.isView}
                                >
                                    <InputLabel htmlFor="outlined-age-native-simple">Setor da Despesa</InputLabel>

                                    <ComboSetor
                                        name={'codsetordespesa'}
                                        label={'Setor da Despesa'}
                                        value={servico.codsetordespesa}
                                        onChange={this.OnChange}
                                        fieldId={'codsetor'}
                                        listItems={setoresdespesa}
                                        fieldDescription={'descsetor'}
                                    />
                                </FormControl>
                            </FormGroup>

                            <FormGroup row>
                                {trabtipopadraoservico && (
                                    <FormControl
                                        style={{ marginTop: '20px', width: '225px', marginRight: '10px' }}
                                        variant="outlined"
                                        disabled={this.state.isView}
                                    >
                                        <InputLabel htmlFor="outlined-age-native-simple">Tipo serviço padrão</InputLabel>

                                        <ComboTipoServico
                                            name={'tiposervpadrao'}
                                            label={'Tipo serviço padrão'}
                                            value={servico.tiposervpadrao}
                                            onChange={this.OnChange}
                                        />
                                    </FormControl>)
                                }

                                <CurrencyTextField
                                    className={this.state.useStyles.textField}
                                    label="Comissão Vendedor"
                                    style={{ marginRight: '10px', marginTop: '20px', width: '225px' }}
                                    name="perccomissvendedor"
                                    id="perccomissvendedor"
                                    value={servico.perccomissvendedor || ''}
                                    variant="outlined"
                                    currencySymbol="%"
                                    outputFormat="number" // Use 'string' para manter a formatação personalizada
                                    decimalCharacter="," // Define a vírgula como o separador decimal
                                    digitGroupSeparator="." // Define o ponto como o separador de milhar
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    minimumValue="0"
                                />

                                {((codpais == tPais['APAISCHILE']) ? null : (
                                    <CurrencyTextField
                                        className={this.state.useStyles.textField}
                                        label={(coddialeto == tDialeto['ADialetoFrancesFranca']) ? "TVA" : "ISS"}
                                        style={{ marginTop: '20px', width: '225px' }}
                                        name="perciss"
                                        id="perciss"
                                        value={servico.perciss || ''}
                                        variant="outlined"
                                        currencySymbol="%"
                                        outputFormat="number"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        onChange={this.OnChange}
                                        disabled={this.state.isView}
                                        minimumValue="0"
                                    />))}
                            </FormGroup>

                            {exibecustopadraocadservico && (
                                <FormGroup row>
                                    <CurrencyTextField
                                        className={this.state.useStyles.textField}
                                        label="Custo Unit. ADT"
                                        style={{ marginTop: '25px', marginRight: '10px', width: '150px' }}
                                        name="custounitadt"
                                        id="custounitadt"
                                        value={servico.custounitadt || ''}
                                        variant="outlined"
                                        currencySymbol=""
                                        outputFormat="number"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        onChange={this.OnChange}
                                        disabled={this.state.isView}
                                        minimumValue="0"
                                    />

                                    <CurrencyTextField
                                        className={this.state.useStyles.textField}
                                        label="Custo Unit. CHD"
                                        style={{ marginTop: '25px', marginRight: '10px', width: '150px' }}
                                        name="custounitchd"
                                        id="custounitchd"
                                        value={servico.custounitchd || ''}
                                        variant="outlined"
                                        currencySymbol=""
                                        outputFormat="number"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        onChange={this.OnChange}
                                        disabled={this.state.isView}
                                        minimumValue="0"
                                    />

                                    <CurrencyTextField
                                        className={this.state.useStyles.textField}
                                        label="Custo Unit. INF"
                                        style={{ marginTop: '25px', marginRight: '10px', width: '150px' }}
                                        name="custounitinf"
                                        id="custounitinf"
                                        value={servico.custounitinf || ''}
                                        variant="outlined"
                                        currencySymbol=""
                                        outputFormat="number"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        onChange={this.OnChange}
                                        disabled={this.state.isView}
                                        minimumValue="0"
                                    />

                                    <CurrencyTextField
                                        className={this.state.useStyles.textField}
                                        label="Custo Unit. SEN"
                                        style={{ marginTop: '25px', marginRight: '10px', width: '150px' }}
                                        name="custounitsen"
                                        id="custounitsen"
                                        value={servico.custounitsen || ''}
                                        variant="outlined"
                                        currencySymbol=""
                                        outputFormat="number"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        onChange={this.OnChange}
                                        disabled={this.state.isView}
                                        minimumValue="0"
                                    />

                                    <CurrencyTextField
                                        className={this.state.useStyles.textField}
                                        label="Custo Unit."
                                        style={{ marginTop: '25px', marginRight: '10px', width: '150px' }}
                                        name="custounit"
                                        id="custounit"
                                        value={servico.custounit || ''}
                                        variant="outlined"
                                        currencySymbol=""
                                        outputFormat="number"
                                        decimalCharacter=","
                                        digitGroupSeparator="."
                                        onChange={this.OnChange}
                                        disabled={this.state.isView}
                                        minimumValue="0"
                                    />
                                </FormGroup>)
                            }

                            {((!((vincservaservtransp) && (servico.servicopasseio == ASIM))) ? null : (
                                <FormControl
                                    fullWidth
                                    style={{ marginTop: '20px', marginRight: '10px' }}
                                    variant="outlined"
                                    disabled={this.state.isView}
                                >
                                    <InputLabel htmlFor="outlined-age-native-simple">Vinculado com serviço de transporte</InputLabel>

                                    <ComboPadrao
                                        name={'codservtransp'}
                                        label={'Vinculado com serviço de transporte'}
                                        value={servico.codservtransp}
                                        onChange={this.OnChange}
                                        fieldId={'codservico'}
                                        listItems={servicosvinctransp}
                                        fieldDescription={'descservico'}
                                    />

                                </FormControl>))
                            }

                            {(!(controlapontosservico || (hsunicapresopcguia))) ? null : (
                                <FormGroup
                                    row
                                    style={{ marginTop: '20px' }}
                                >
                                    {hsunicapresopcguia && (
                                        <TextField
                                            InputLabelProps={{ shrink: true, required: false }}
                                            inputProps={{ maxLength: 50 }}
                                            label="Apresentação Guia"
                                            name="hsunicapresopcguia"
                                            onChange={this.OnChange}
                                            style={{ width: '150px' }}
                                            type="time"
                                            value={servico.hsunicapresopcguia || ''}
                                            variant="outlined"
                                            disabled={this.state.isView}
                                        />)
                                    }

                                    {controlapontosservico && (
                                        <FormGroup row>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={(servico.controlapontuacao === ASIM)}
                                                        name="controlapontuacao"
                                                        onChange={this.OnChange}
                                                        color="primary"
                                                        disabled={this.state.isView}
                                                    />}
                                                style={{ marginLeft: ((hsunicapresopcguia) ? '10px' : '') }}
                                                label={'Controla pontuação'}
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={(servico.essencialparapontuacao === ASIM)}
                                                        name="essencialparapontuacao"
                                                        onChange={this.OnChange}
                                                        color="primary"
                                                        disabled={this.state.isView}
                                                    />}
                                                style={{ display: ((servico.controlapontuacao === ASIM) ? '' : 'none') }}
                                                label={'Essencial na pontuação'}
                                            />

                                            <TextField
                                                className={this.state.useStyles.textField}
                                                label="Pontos"
                                                style={{ width: '100px', display: ((servico.controlapontuacao === ASIM) ? '' : 'none') }}
                                                name="pontos"
                                                value={servico.pontos || ''}
                                                variant="outlined"
                                                onChange={this.OnChange}
                                                disabled={this.state.isView}
                                                type="number"
                                            />
                                        </FormGroup>)
                                    }
                                </FormGroup>)
                            }

                            {exibenomeservnoforneccadserv && (
                                <TextField
                                    fullWidth
                                    className={this.state.useStyles.textField}
                                    label="Descrição do serviço no fornecedor"
                                    style={{ marginTop: '20px' }}
                                    name="nomeserviconofornec"
                                    value={servico.nomeserviconofornec || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 100 }}
                                />)
                            }

                            <FormControl
                                fullWidth
                                style={{ marginTop: '20px' }}
                                variant="outlined"
                                disabled={this.state.isView}
                            >
                                {selectedCity && (
                                    <>
                                        {/* Renderiza o CitySearch passando a função handleCitySelection como prop */}
                                        <SearchCidade
                                            defaultCity={selectedCity || ''}
                                            onCitySelect={this.handleCitySelection}
                                        />
                                        <div>
                                        </div>
                                    </>
                                )}

                                <br />
                            </FormControl>

                            <FormGroup row={true}>
                                <TextField
                                    className={this.state.useStyles.textField}
                                    label="Sort Order"
                                    style={{ width: '100px', marginRight: '10px' }}
                                    name="sortorder"
                                    value={servico.sortorder || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    type="number"
                                />

                                {controlaservicoscompulseira && (
                                    <TextField
                                        className={this.state.useStyles.textField}
                                        label="Código de barras pulseira"
                                        style={{ width: '200px' }}
                                        name="referenciacodbarrapulseira"
                                        value={servico.referenciacodbarrapulseira || ''}
                                        variant="outlined"
                                        onChange={this.OnChange}
                                        disabled={this.state.isView}
                                        inputProps={{ maxLength: 20 }}
                                    />)}
                            </FormGroup>

                            {multipdv && (
                                <Box>
                                    <FormLabel
                                        component="legend"
                                        style={{
                                            marginTop: '20px',
                                            textAlign: 'center',
                                            backgroundColor: '#e0e0e0',
                                            padding: '3px',
                                        }}
                                        disabled={this.state.isView}
                                    > Pontos de venda do serviço
                                    </FormLabel>
                                    <Table className={''} aria-label="caption table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography
                                                        color="textSecondary"
                                                        component="p"
                                                        variant="body2"
                                                    >
                                                        Marcado
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography
                                                        color="textSecondary"
                                                        component="p"
                                                        variant="body2"
                                                    >
                                                        PDV
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {pdvsservico.map((pdv, index) => (
                                                <TableRow key={pdv.codpdvconfig}>
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            color="primary"
                                                            checked={pdv.marcado === ASIM}
                                                            onChange={this.OnChangePDV}
                                                            id={index}
                                                        />
                                                    </TableCell>

                                                    <TableCell align="left" width="250">{pdv.descpdv}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>

                                    <FormLabel
                                        component="legend"
                                        style={{
                                            textAlign: 'center',
                                            backgroundColor: '#e0e0e0',
                                            padding: '3px'
                                        }}
                                        disabled={this.state.isView}
                                    >
                                    </FormLabel>
                                </Box>
                            )
                            }
                        </TabContainer>
                    }

                    {/* Aba Descritivo */}
                    {activetab === 1 &&
                        <TabContainer>
                            <FormGroup>
                                <AppBar
                                    color="default"
                                    position="static"
                                >
                                    <Tabs
                                        indicatorColor="primary"
                                        onChange={this.handleChangeTabDescritivo}
                                        scrollButtons="auto"
                                        scrollable
                                        variant="fullWidth"
                                        centered="true"
                                        textColor="primary"
                                        value={activetabdescritivo}
                                    >
                                        <Tab
                                            label="Português"
                                        />

                                        <Tab
                                            label="Espanhol"
                                        />

                                        <Tab
                                            label="Inglês"
                                        />
                                    </Tabs>
                                </AppBar>

                                {/* Aba Português */}
                                {activetabdescritivo === 0 &&
                                    <TabContainer>
                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Descritivo do Serviço
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="descritivo"
                                                name="descritivo"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.descritivo}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>

                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Informativo do Serviço
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="informativo"
                                                name="informativo"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.informativo}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>

                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Política de Cancelamento
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="politicacancelamento"
                                                name="politicacancelamento"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.politicacancelamento}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>
                                    </TabContainer>
                                }

                                {/* Aba Espanhol */}
                                {activetabdescritivo === 1 &&
                                    <TabContainer>
                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Descritivo do Serviço
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="descritivoesp"
                                                name="descritivoesp"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.descritivoesp}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>

                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Informativo do Serviço
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="informativoesp"
                                                name="informativoesp"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.informativoesp}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>

                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Política de Cancelamento
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="politicacancelamentoesp"
                                                name="politicacancelamentoesp"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.politicacancelamentoesp}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>
                                    </TabContainer>
                                }

                                {/* Aba Inglês */}
                                {activetabdescritivo === 2 &&
                                    <TabContainer>
                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Descritivo do Serviço
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="descritivoing"
                                                name="descritivoing"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.descritivoing}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>

                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Informativo do Serviço
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="informativoing"
                                                name="informativoing"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.informativoing}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>

                                        <FormLabel
                                            component="legend"
                                            style={{ marginTop: '1rem' }}
                                            disabled={this.state.isView}
                                        > Política de Cancelamento
                                        </FormLabel>
                                        <FormGroup>
                                            <textarea
                                                id="politicacancelamentoing"
                                                name="politicacancelamentoing"
                                                onChange={this.OnChange}
                                                style={{ height: '100px' }}
                                                type="textarea"
                                                value={servico.politicacancelamentoing}
                                                disabled={this.state.isView}
                                            />
                                        </FormGroup>
                                    </TabContainer>
                                }

                            </FormGroup>

                            {!(trabmaisumaafinidadeservico) && (
                                <FormControl
                                    fullWidth
                                    style={{ marginRight: '10px', marginTop: '20px' }}
                                    variant="outlined"
                                    disabled={this.state.isView}
                                >
                                    <InputLabel htmlFor="outlined-age-native-simple">Afinidade</InputLabel>

                                    <ComboPadrao
                                        name={'idafinidade'}
                                        label={'Afinidade'}
                                        value={servico.idafinidade}
                                        onChange={this.OnChange}
                                        fieldId={'id'}
                                        listItems={afinidadesservico}
                                        fieldDescription={'descafinidade'}
                                    />

                                </FormControl>)
                            }

                            {trabmaisumaafinidadeservico && (
                                <Box>
                                    <FormLabel
                                        component="legend"
                                        style={{
                                            marginTop: '20px',
                                            textAlign: 'center',
                                            backgroundColor: '#e0e0e0',
                                            padding: '3px',
                                        }}
                                        disabled={this.state.isView}
                                    > Afinidades
                                    </FormLabel>
                                    <Table className={''} aria-label="caption table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography
                                                        color="textSecondary"
                                                        component="p"
                                                        variant="body2"
                                                    >
                                                        Marcado
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography
                                                        color="textSecondary"
                                                        component="p"
                                                        variant="body2"
                                                    >
                                                        Afinidade
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {afinidadesservico.map((afinidade, index) => (
                                                <TableRow key={afinidade.id}>
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            color="primary"
                                                            checked={afinidade.marcado === ASIM}
                                                            onChange={this.OnChangeAfinidade}
                                                            id={index}
                                                        />
                                                    </TableCell>

                                                    <TableCell align="left" width="250">{afinidade.descafinidade}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>

                                    <FormLabel
                                        component="legend"
                                        style={{
                                            textAlign: 'center',
                                            backgroundColor: '#e0e0e0',
                                            padding: '3px'
                                        }}
                                        disabled={this.state.isView}
                                    >
                                    </FormLabel>
                                </Box>
                            )
                            }


                            <FormControl
                                fullWidth
                                style={{ marginRight: '10px', marginTop: '20px' }}
                                variant="outlined"
                                disabled={this.state.isView}
                            >
                                <InputLabel htmlFor="outlined-age-native-simple">Local</InputLabel>

                                <ComboPadrao
                                    name={'codlocal'}
                                    label={'Local'}
                                    value={servico.codlocal}
                                    onChange={this.OnChange}
                                    fieldId={'codorigemdestino'}
                                    listItems={locais}
                                    fieldDescription={'descorigemdestino'}
                                />

                                <br />
                            </FormControl>

                            <Divider style={{ backgroundColor: colors.grey[400], marginTop: '10px' }} />

                            <Typography style={{ marginTop: '5px', color: colors.grey[600] }}>
                                Outras opções
                            </Typography>

                            <FormGroup row={true}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.novidade === ASIM)}
                                            name="novidade"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'É novidade?'}
                                />

                                <TextField
                                    className={this.state.useStyles.textField}
                                    label="Duração"
                                    style={{ width: '300px' }}
                                    name="duracao"
                                    value={servico.duracao || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    inputProps={{ maxLength: 50 }}
                                />
                            </FormGroup>

                            <Divider style={{ backgroundColor: colors.grey[400], marginTop: '10px' }} />
                        </TabContainer>
                    }

                    {/* Aba PDV Móvel */}
                    {activetab === 2 &&
                        <TabContainer>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={(servico.atualizainfpdvmovel === ASIM)}
                                        name="atualizainfpdvmovel"
                                        onChange={this.OnChange}
                                        color="primary"
                                        disabled={this.state.isView}
                                    />}
                                label={'Atualiza informações para PDV Móvel'}
                            />
                        </TabContainer>
                    }

                    {/* Aba Fornecedores */}
                    {activetab === 3 &&
                        <TabContainer>
                            <Box>
                                <FormLabel
                                    component="legend"
                                    style={{
                                        textAlign: 'center',
                                        backgroundColor: '#e0e0e0',
                                        padding: '3px',
                                    }}
                                    disabled={this.state.isView}
                                > Fornecedores do serviço
                                </FormLabel>

                                <Table className={''} aria-label="caption table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <Typography
                                                    color="textSecondary"
                                                    component="p"
                                                    variant="body2"
                                                >
                                                    Principal
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography
                                                    color="textSecondary"
                                                    component="p"
                                                    variant="body2"
                                                >
                                                    Tipo
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography
                                                    color="textSecondary"
                                                    component="p"
                                                    variant="body2"
                                                >
                                                    Fornecedor
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography
                                                    color="textSecondary"
                                                    component="p"
                                                    variant="body2"
                                                >
                                                    Ações
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fornecedoresservico.map((fornecedorservico, index) => (
                                            <TableRow key={fornecedorservico.chave}>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        color="primary"
                                                        checked={(fornecedorservico.codfornecedor === servico.codfornecprincipal) ? true : false}
                                                        onChange={this.OnChangeFornecedor}
                                                        id={fornecedorservico.codfornecedor}
                                                    />
                                                </TableCell>

                                                <TableCell align="left">
                                                    {this.getTipoFornec(fornecedorservico.tipofornec)}
                                                </TableCell>

                                                {!isLoadingFornecedor && (
                                                    <TableCell align="left">
                                                        {servFornec[fornecedorservico.codfornecedor] || ''}
                                                    </TableCell>
                                                )}

                                                <TableCell>
                                                    <Button
                                                        color="primary"
                                                        onClick={() => this.openFornecedorModal(fornecedorservico.chave)}
                                                    >
                                                        <EditIcon />
                                                    </Button>

                                                    <Button
                                                        color="primary"
                                                        onClick={() => this.openFornecedorDeleteModal(fornecedorservico.chave, index, servFornec[fornecedorservico.codfornecedor])}
                                                    >
                                                        <DeleteOutlineIcon />
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>

                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button
                                        color="primary"
                                        // className={classes.addButton}
                                        variant="contained"
                                        onClick={() => this.openFornecedorModal('novo')}
                                        disabled={this.state.isView}
                                        style={{
                                            backgroundColor: colors.grey[300],
                                            color: 'black',
                                            marginTop: '5px'
                                        }}
                                    >
                                        Inserir
                                    </Button>
                                </div>

                                <FormLabel
                                    component="legend"
                                    style={{
                                        textAlign: 'center',
                                        backgroundColor: '#e0e0e0',
                                        padding: '3px',
                                        marginTop: '5px'
                                    }}
                                    disabled={this.state.isView}
                                >
                                </FormLabel>
                            </Box>

                            {((!((recebdiretofornec) && (detalhaformapgtofornec) &&
                                (contrservrecebfornec))) ? null : (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={(servico.recebenofornecedor === ASIM)}
                                            name="recebenofornecedor"
                                            onChange={this.OnChange}
                                            color="primary"
                                            disabled={this.state.isView}
                                        />}
                                    label={'Recebe no fornecedor'}
                                />))
                            }

                        </TabContainer>
                    }

                    {/* Aba App Cliente */}
                    {activetab === 4 &&
                        <TabContainer>
                            <TextField
                                fullWidth
                                className={this.state.useStyles.textField}
                                label="Descrição do serviço para App Cliente"
                                name="descservicoappcli"
                                value={servico.descservicoappcli || ''}
                                variant="outlined"
                                onChange={this.OnChange}
                                disabled={this.state.isView}
                                inputProps={{ maxLength: 100 }}
                            />

                            <FormLabel
                                component="legend"
                                style={{ marginTop: '10px' }}
                                disabled={this.state.isView}
                            > Descritivo serviço para App Cliente
                            </FormLabel>
                            <FormGroup>
                                <textarea
                                    id="descritivoappcli"
                                    name="descritivoappcli"
                                    onChange={this.OnChange}
                                    style={{ height: '100px' }}
                                    type="textarea"
                                    value={servico.descritivoappcli}
                                    disabled={this.state.isView}
                                />
                            </FormGroup>

                            < br />

                            <TextField
                                InputLabelProps={{ shrink: true, required: false }}
                                inputProps={{ maxLength: 50 }}
                                label="Hora ordenação"
                                name="horaordappcli"
                                onChange={this.OnChange}
                                style={{ width: '150px' }}
                                type="time"
                                value={servico.horaordappcli || ''}
                                variant="outlined"
                                disabled={this.state.isView}
                            />
                        </TabContainer>
                    }

                    {/* Aba Snowland */}
                    {activetab === 5 &&
                        <TabContainer>
                            <FormGroup row={true}>
                                <TextField
                                    className={this.state.useStyles.textField}
                                    label="Código ADT"
                                    style={{ width: '150px', marginRight: '10px' }}
                                    name="codservsnowadt"
                                    value={servico.codservsnowadt || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    type="number"
                                />

                                <TextField
                                    className={this.state.useStyles.textField}
                                    label="Código CHD"
                                    style={{ width: '150px', marginRight: '10px' }}
                                    name="codservsnowchd"
                                    value={servico.codservsnowchd || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    type="number"
                                />

                                <TextField
                                    className={this.state.useStyles.textField}
                                    label="Código SEN"
                                    style={{ width: '150px', marginRight: '10px' }}
                                    name="codservsnowsen"
                                    value={servico.codservsnowsen || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    type="number"
                                />

                                <TextField
                                    className={this.state.useStyles.textField}
                                    label="Código INF"
                                    style={{ width: '150px' }}
                                    name="codservsnowinf"
                                    value={servico.codservsnowinf || ''}
                                    variant="outlined"
                                    onChange={this.OnChange}
                                    disabled={this.state.isView}
                                    type="number"
                                />
                            </FormGroup>
                        </TabContainer>
                    }

                    {/* Aba Serviços de Apoio */}
                    {activetab === 6 &&
                        <TabContainer>
                            <FormControl
                                disabled={this.state.isView}
                                style={{ display: ((servico.servicoapoio == ASIM) ? '' : 'none') }}
                            >
                                <FormLabel>Tipo</FormLabel>
                                <RadioGroup
                                    row
                                    name="tiposervicoapoio"
                                    value={servico.tiposervicoapoio || ''}
                                    onChange={this.OnChange}
                                >
                                    <FormControlLabel value={ATIPO_SERVICOAPOIO_IDA} control={<Radio />} label="Ida" />
                                    <FormControlLabel value={ATIPO_SERVICOAPOIO_RETORNO} control={<Radio />} label="Retorno" />
                                </RadioGroup>
                            </FormControl>
                        </TabContainer>
                    }

                    {/* Aba Impostos */}
                    {activetab === 7 &&
                        <TabContainer>
                            <CurrencyTextField
                                className={this.state.useStyles.textField}
                                label="IVA"
                                style={{ marginTop: '20px', marginRight: '10px', width: '150px' }}
                                name="perciva"
                                id="perciva"
                                value={servico.perciva || ''}
                                variant="outlined"
                                currencySymbol="%"
                                outputFormat="number"
                                decimalCharacter=","
                                digitGroupSeparator="."
                                onChange={this.OnChange}
                                disabled={this.state.isView}
                                minimumValue="0"
                            />

                            <CurrencyTextField
                                className={this.state.useStyles.textField}
                                label="IVA Isento"
                                style={{ marginTop: '20px', width: '150px' }}
                                name="percivaisento"
                                id="percivaisento"
                                value={servico.percivaisento || ''}
                                variant="outlined"
                                currencySymbol="%"
                                outputFormat="number"
                                decimalCharacter=","
                                digitGroupSeparator="."
                                onChange={this.OnChange}
                                disabled={this.state.isView}
                                minimumValue="0"
                            />
                        </TabContainer>
                    }

                    {/* Aba Grupo */}
                    {activetab === 8 &&
                        <TabContainer>
                            <Box>
                                <FormLabel
                                    component="legend"
                                    style={{
                                        textAlign: 'center',
                                        backgroundColor: '#e0e0e0',
                                        padding: '3px',
                                    }}
                                    disabled={this.state.isView}
                                > Serviços do grupo
                                </FormLabel>

                                <Table className={''} aria-label="caption table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <Typography
                                                    color="textSecondary"
                                                    component="p"
                                                    variant="body2"
                                                >
                                                    Código
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography
                                                    color="textSecondary"
                                                    component="p"
                                                    variant="body2"
                                                >
                                                    Serviço
                                                </Typography>
                                            </TableCell>

                                            <TableCell>
                                                <Typography
                                                    color="textSecondary"
                                                    component="p"
                                                    variant="body2"
                                                >
                                                    Ações
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {servicosgrupo.map((servicogrupo, index) => (
                                            <TableRow key={servicogrupo.id}>
                                                <TableCell align="left">
                                                    {servicogrupo.codservicogrupo}
                                                </TableCell>

                                                {!isLoadingServGrupo && (
                                                    <TableCell align="left">
                                                        {servGrupo[servicogrupo.codservicogrupo] || ''}
                                                    </TableCell>
                                                )}

                                                <TableCell>
                                                    <Button
                                                        color="primary"
                                                        onClick={() => this.openServicoGrupoDeleteModal(servicogrupo.id, index, servGrupo[servicogrupo.codservicogrupo])}
                                                    >
                                                        <DeleteOutlineIcon />
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>

                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button
                                        color="primary"
                                        // className={classes.addButton}
                                        variant="contained"
                                        onClick={() => this.openServicoGrupoModal('novo')}
                                        disabled={this.state.isView}
                                        style={{
                                            backgroundColor: colors.grey[300],
                                            color: 'black',
                                            marginTop: '5px'
                                        }}
                                    >
                                        Inserir
                                    </Button>
                                </div>

                                <FormLabel
                                    component="legend"
                                    style={{
                                        textAlign: 'center',
                                        backgroundColor: '#e0e0e0',
                                        padding: '3px',
                                        marginTop: '5px'
                                    }}
                                    disabled={this.state.isView}
                                >
                                </FormLabel>
                            </Box>
                        </TabContainer>
                    }

                    <br />

                    <br />
                    <br />

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={this.state.isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickCancel}
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                    >
                        Cancelar
                    </Button>
                </CardContent>

                <ConfirmationModal
                    open={this.state.openConfirmation}
                    handleClose={() => this.handleCloseConfirmation()}
                    title={'Informação'}
                    message={this.state.messageConfirmation}
                    handleConfirmation={() => this.handleConfirmation(this.state.messageConfirmation)}
                />

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />

                {/* Horários padrões */}
                <Dialog open={this.state.openHorariosPadroes} onClose={this.handleCloseHorariosPadroes} maxWidth="md" fullWidth>
                    <DialogTitle className={classes.dialogTitle}>Horários padrões do serviço</DialogTitle>
                    <DialogContent className={classes.dialogContent}>
                        <HorarioPadraoServico
                            codServico={servico.codservico}
                            horariosServico={this.state.horariosservico}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseHorariosPadroes} color="primary">
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Exclusão de Fornecedor */}
                <DeleteConfirmationModal
                    open={this.state.isFornecedorDeleteModalOpen}
                    handleClose={() => this.closeFornecedorDeleteModal()}
                    itemId={this.state.selectedIdFornecedor}
                    message={"Confirma exclusão do fornecedor " + this.state.selectedNomeFornecedor + '?'}
                    handleDelete={() => this.handleDeleteFornecedor(this.state.selectedIdFornecedor, this.state.selectedIndexFornecedor)}
                />

                {/* Form fornecedores serviço */}
                <Modal
                    open={this.state.openFornecedorServicoForm}
                    onClose={this.handleFornecedorServicoFormClose}
                >
                    <div>
                        <FornecedorServicoForm
                            fornecedorservico={this.state.selectedFornecedor} // passa objetoFornecedorselecionado para o formulário.
                            onClose={this.handleFornecedorServicoFormClose}
                            onSave={(updateFornecedor) => {
                                this.handleFornecedorServicoFormClose(); // Fechar o modal
                                this.updateFornecedorList(updateFornecedor); // Atualizar a lista de pax
                            }}
                            isModal={true}
                            codServico={servico.codservico}
                            id={this.state.selectedIdFornecedor}  // Passe o ID do Pax ou 'novo' para um novo registro
                        />
                    </div>
                </Modal>

                {/* Exclusão de serviço grupo */}
                <DeleteConfirmationModal
                    open={this.state.isServicoGrupoDeleteModalOpen}
                    handleClose={() => this.closeServicoGrupoDeleteModal()}
                    itemId={this.state.selectedIdServicoGrupo}
                    message={"Confirma exclusão do serviço " + this.state.selectedNomeServicoGrupo + '?'}
                    handleDelete={() => this.handleDeleteServicoGrupo(this.state.selectedIdServicoGrupo, this.state.selectedIndexServicoGrupo)}
                />

                {/* Form serviço grupo */}
                <Modal
                    open={this.state.openServicoGrupoForm}
                    onClose={this.handleServicoGrupoFormClose}
                >
                    <div>
                        <GrupoServicoForm
                            servicogrupo={this.state.selectedServicoGrupo}
                            onClose={this.handleServicoGrupoFormClose}
                            onSave={(updateServicoGrupo) => {
                                this.handleServicoGrupoFormClose(); // Fechar o modal
                                this.updateServicoGrupoList(updateServicoGrupo); // Atualizar lista
                            }}
                            isModal={true}
                            codServico={servico.codservico}
                            id={this.state.selectedIdServicoGrupo}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

ServicoForm.propTypes =
{
    classes: PropTypes.object.isRequired
};

//export default ServicoForm;
export default withStyles(styles)(ServicoForm);